import React, { useState } from "react";
import DropdownPubUser from "./DropdownPubUser";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function PubUserBody() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    search: ''
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const handleClick = () => {
    // Check if the search input is empty before navigating
    if (data.search.trim() !== "") {
      // Use the navigate function to navigate and pass data as state
      navigate("/pubUserSearch", { state: { searchData: data } });
    }
    // If search input is empty, do nothing
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "20vh" }}>
        <input
          type="text"
          name="search"
          id="nameInput"
          className="form-control w-50 mr-2"
          placeholder="Type item here"
          onChange={handleChange}
          required
        />
        <button className="btn btn-primary ml-2 text-center rounded-pill shadow" onClick={handleClick}>
          <FaSearch className="mb-1" /> Search
        </button>
      </div>
      <DropdownPubUser className="d-flex flex-row justify-content-around align-items-center" />
    </div>
  );
}
